export enum OmexMetadataInputFormat {
  ntriples = 'ntriples',
  nquads = 'nquads',
  rdfa = 'rdfa',
  rdfxml = 'rdfxml',
  turtle = 'turtle',
}

export enum OmexMetadataSchema {
  BioSimulations = 'BioSimulations',
  rdf_triples = 'rdf_triples',
}
